import { Geojson } from "../Map/types";
import { useCallback, useState } from "react";
import { fetchSchemeShapefile } from "../misc";
import { useAsync } from "./useAsync";

export const useShapefileData = () => {
    const load = useCallback(async (signal?: AbortSignal): Promise<Geojson> => {
        return fetchSchemeShapefile({
            signal
        });
    }, []);

    const [schemeShape, setSchemeShape] = useState<Geojson>();

    useAsync(load, setSchemeShape);

    return { scheme: schemeShape };
};
